import { render } from "./ListsManageActions.vue?vue&type=template&id=36b2d0da&scoped=true"
import script from "./ListsManageActions.vue?vue&type=script&lang=ts"
export * from "./ListsManageActions.vue?vue&type=script&lang=ts"

import "./ListsManageActions.vue?vue&type=style&index=0&id=36b2d0da&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-36b2d0da"

export default script